import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ListIcon from '@material-ui/icons/List';
import { MouseEvent } from 'react';
import { useFloatingEbookActionsStyles } from './FloatingEbookActions.styles';

type FloatingEbookActionsProps = {
  summaryHref?: string;
};

const FloatingEbookActions = ({ summaryHref = 'page-6' }: FloatingEbookActionsProps) => {
  const classes = useFloatingEbookActionsStyles();

  const handleBackToTop = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={classes.floatingActions}>
      <a href={`#${summaryHref}`} className={classes.summaryButton} aria-label="Aller au sommaire">
        <ListIcon className={classes.summaryIcon} />
        <span>Sommaire</span>
      </a>

      <a
        href="#ebook-top"
        className={classes.backToTopButton}
        aria-label="Revenir en haut de l’ebook"
        onClick={handleBackToTop}>
        <KeyboardArrowUpIcon />
      </a>
    </div>
  );
};

export default FloatingEbookActions;
